export class EnterpriseDashboardBudgetStats {
	public budgetMetrics: {
		budgetActualCost: number;
		nextBudgetCost: number;
		underBudgetPercent: number;
		monthlyBudgetActualCost: number;
		monthOverMonthChangePercent: number;
	};
	public budgetChartData: {
		date: Date;
		budgetActualCost: number;
		nextBudgetCost: number;
	}[];

	public contracts: {
		originContractId: string;
		dbaName: string;
	}[];

	constructor(enterpriseDashboardBudgetStats?: EnterpriseDashboardBudgetStats) {
		Object.assign(this, enterpriseDashboardBudgetStats);
	}
}
